<div mat-dialog-content class="cancel">
    <p align="center">Are you sure you want to cancel?</p>
</div>
<br/>
<div mat-dialog-actions align="center">
    <button mat-stroked-button class="secondary-btn-action" color="primary" mat-dialog-close>No, Continue</button>
    <button mat-flat-button class="primary-btn-action" color="primary" [mat-dialog-close]="true" cdkFocusInitial>Yes, Cancel</button>
</div>
